<div class="form-group">
  <div *ngIf="props.label && props.hideLabel !== true">
    <label [attr.for]="id">
      {{ props.label }} <small *ngIf="fileSize">{{ fileSize }} </small><small *ngIf="fileType">{{ fileType }}</small>
      <span *ngIf="props.required && props.hideRequiredMarker !== true">*</span>
    </label>
  </div>

  <div class="file-card-body" style="margin: 0">
    <div [class.has-error]="formControl.errors">
      <label (fileOver)="fileOver($event)" (onFileDrop)="upload()" [ngClass]="{'file-over': hasDropZoneOver}" [uploader]="uploader" class="well my-drop-zone" for="uploader-input" i18n="@ClickOrDragImage" ng2FileDrop>
        <nb-icon icon="upload-outline"/>
        {{ fileName }}
      </label>
      <input (change)="upload()" [uploader]="uploader" id="uploader-input" multiple ng2FileSelect style="display: none" type="file"/>

      <div class="my-drop-zone-info">
        <div i18n="@@MaxFileSize">Максимальный размер файла {{ maxFileSize }}</div>
        <div *ngIf="allowedMimeTypes" i18n="@@AllowedMimes">Доступные типы файла {{ allowedMimeTypes.join(', ') }}</div>
        <div *ngIf="props.description" class="form-text text-muted">{{ props.description }}</div>

        <div *ngIf="showError" class="invalid-feedback">
          <formly-validation-message [field]="field"></formly-validation-message>
        </div>
      </div>
    </div>
  </div>

</div>
